// Code common to all site pages lives here

/* global jQuery */

const $             = jQuery;   // jQuery loaded via WordPress enqueue process
// const dc            = require('./utilities/device-check');
const header        = require('./components/header');
// const lity          = require('lity');
// const anims			= require('./components/anims');

function initHeader() {
	// console.log("initHeader()");
    let $header = $('.site-header');
    if ($header.length) {
        header.init($header);
    }
}

exports.init = function() {
    // Do common initialization...
    initHeader();
};
